import axios from 'axios';
import useTokenStore from '@store/token-store/token.store.ts';
import useAuthStore from '@store/auth-store/auth.store.ts';
import { getApiBaseUrl } from '@shared/config/runtime-config';

const superAdminAxios = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

superAdminAxios.interceptors.request.use(
  (config) => {
    if (!config.baseURL) {
      config.baseURL = getApiBaseUrl();
    }

    const { superAdminAccessToken } = useTokenStore.getState();
    if (superAdminAccessToken) {
      config.headers.Authorization = `Bearer ${superAdminAccessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

superAdminAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const currentPath = window.location.pathname;

      if (
        (status === 401 || status === 403) &&
        !currentPath.startsWith('/auth')
      ) {
        const { logout } = useAuthStore.getState();
        logout();
      }
      console.warn(`[superAdminAxios] ${status} error on ${currentPath}`, error.response);
    }

    return Promise.reject(error);
  }
);

export default superAdminAxios;
